import React, { useState, useEffect } from "react";
import { Form, Col, Button, Tooltip, OverlayTrigger, Row, Container } from 'react-bootstrap';
import { useDispatch } from 'redux-react-hook';
import { InfoCircle } from 'react-bootstrap-icons';

export default function ArraySetting(props) {
    const questionIndex = props.index;
    // const data = props.data || { is_rand: 0, rand: [], ty: 0 };
    const [data, setData] = useState(props.data || []);
    const dispatch = useDispatch();
    const isDebug = false;

    function logDebug(content) {
        if (isDebug) console.log(content);
    }

    // useEffect(() => {
    //     logDebug(props.data)
    //     let tmpData = { ...props.data };
    //     if (null == tmpData || null == tmpData.length) {
    //         tmpData = [""]
    //     }
    //     setData(tmpData);
    // }, [props.data]);

    const EType = {
        Satisfaction: 1,
        Agreement: 2,
        Frequency: 3
    }

    function setPreset(etype) {
        try {
            let tmpAry = [...data];
            switch (etype) {
                case EType.Satisfaction:
                    tmpAry = ["非常不滿意", "不滿意", "普通", "滿意", "非常滿意"];
                    break;
                case EType.Agreement:
                    tmpAry = ["非常不同意", "不同意", "普通", "同意", "非常同意"];
                    break;
                case EType.Frequency:
                    tmpAry = ["幾乎不會", "偶爾", "一般", "經常", "總是如此"];
                    break;
            }
            setData(tmpAry);
            dispatch({
                type: "QUESTION_SET_ARRAY",
                index: questionIndex,
                data: tmpAry
            });
        } catch (e) {
            console.warn(e.stack);
        }
    }

    function onCustomOptChanged(e, index) {
        try {
            let tmp = e.currentTarget.value;

            let tmpAry = [...data];
            tmpAry[index] = tmp;
            logDebug(tmp, e.currentTarget, tmpAry);
            setData(tmpAry);
            dispatch({
                type: "QUESTION_SET_ARRAY",
                index: questionIndex,
                data: tmpAry
            });
        } catch (e) {
            console.warn(e.stack);
        }
    }

    function onCustomOptAdd(index) {
        // console.log(e.currentTarget.value);
        try {
            let tmpAry = [...data];
            tmpAry.splice(index + 1, 0, "");
            logDebug(tmpAry);
            setData(tmpAry);
            dispatch({
                type: "QUESTION_SET_ARRAY",
                index: questionIndex,
                data: tmpAry
            });
        } catch (e) {
            console.warn(e.stack);
        }
    }

    function onCustomOptRemoved(index) {
        // console.log(e.currentTarget.value);
        try {
            let tmpAry = [...data];
            tmpAry.splice(index, 1);
            logDebug(tmpAry);
            setData(tmpAry);
            dispatch({
                type: "QUESTION_SET_ARRAY",
                index: questionIndex,
                data: tmpAry
            });
        } catch (e) {
            console.warn(e.stack);
        }
    }

    // function onCustomOptAdded(e) {
    //     let tmpAry = [...data];
    //     tmpAry.splice(index, 0, "");
    //     dispatch({
    //         type: "QUESTION_SET_ARRAY",
    //         index: questionIndex,
    //         data: tmpAry
    //     });
    // }

    function render() {
        // console.log(subOpt);
        let customOpt = [];
        if (data) {
            for (let i = 0; i < data.length; i++) {
                customOpt.push(
                    <Row key={"rn" + i}>
                        <Col xs={2}><label>{i + 1}</label></Col>
                        <Col xs={3}><input style={{ width: "100%" }} key={i} type="text" value={data[i]} onChange={(event) => onCustomOptChanged(event, i)} /></Col>
                        <Col xs={3}><Button onClick={(event) => onCustomOptAdd(i)}>+</Button></Col>
                        <Col xs={3}><Button onClick={(event) => onCustomOptRemoved(i)}>-</Button></Col>
                    </Row>
                );
            }
        }
        return (
            <Form className="mt-1">
                <Container>
                    <Row>
                        <label>模板參考</label>
                    </Row>
                    <Row className="mb-3">
                        <Button className="mr-1" onClick={() => setPreset(EType.Satisfaction)}>滿意程度</Button>
                        <Button className="mr-1" onClick={() => setPreset(EType.Agreement)}>同意程度</Button>
                        <Button className="mr-1" onClick={() => setPreset(EType.Frequency)}>頻繁程度</Button>
                    </Row>
                </Container>
                <Container>{customOpt}</Container>
            </Form>
        );
    }

    return render();
}
